export const PERSONALIZAR_ROUTES = {
	"/personalizar": "personalizar",
	"/personalizar/checkout": "checkout",
	"/personalizar/page-checkout": "page-checkout",
	"/personalizar/email": "email",
	"/personalizar/marca-agua": "marca-agua",
};

export const PERSONALIZAR_CONTENT_TO_ROUTE = {
	personalizar: "/personalizar",
	checkout: "/personalizar/checkout",
	"page-checkout": "/personalizar/page-checkout",
	email: "/personalizar/email",
	"marca-agua": "/personalizar/marca-agua",
};

export const getPersonalizarContentId = (pathname) => {
	return PERSONALIZAR_ROUTES[pathname] || null;
};

export const isNuvemshopPlatform = () => {
	try {
		const login = JSON.parse(localStorage.getItem("depoimentos@login"));
		return login?.integration?.platform?.toLowerCase() === "nuvemshop";
	} catch {
		return false;
	}
};
